import { gql } from "@apollo/client";

export const getAllTaskGroupQuery = gql`
query{
  getAllTaskLibraryGroup {
    message
    response
  }
}
`;